var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleBigger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.576,
    height: 118.576,
    viewBox: "0 0 118.576 118.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M119.139,59.851A59.288,59.288,0,1,1,59.851.562,59.288,59.288,0,0,1,119.139,59.851ZM52.993,91.243,96.981,47.255a3.825,3.825,0,0,0,0-5.409l-5.409-5.409a3.825,3.825,0,0,0-5.41,0L50.288,72.31,33.539,55.562a3.825,3.825,0,0,0-5.41,0L22.72,60.971a3.825,3.825,0,0,0,0,5.409L47.583,91.243a3.825,3.825,0,0,0,5.41,0Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#1a78f3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBigger);
export default __webpack_public_path__ + "static/media/check_circle_bigger.2af2800f6176fc40586df103a3edac86.svg";
export { ForwardRef as ReactComponent };